import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getNewsUpdatesBySlug } from '../../services/newsupdates';

interface NewsUpdate {
    id: number;
    title: string;
    content: string;
    image?: string;
}

function NewsUpdatesDetailPage() {
    const { slug } = useParams<{ slug: string }>();
    const [news, setNews] = useState<NewsUpdate | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (slug) {
            fetchNewsDetail(slug);
        }
    }, [slug]);

    const fetchNewsDetail = async (newsSlug: string) => {
        setLoading(true);
        const result = await getNewsUpdatesBySlug(newsSlug);
        if (result.success) {
            setNews(result.data);
        } else {
            setError(result.error);
        }
        setLoading(false);
    };

    if (loading) return <div className="text-center py-20">Loading...</div>;
    if (error) return <div className="text-center py-20 text-red-500">{error}</div>;
    if (!news) return null;

    return (
        <section className="py-12 lg:py-24">
            <div className="w-full max-w-[1560px] mx-auto px-4">
                <div className="flex flex-wrap items-center -mx-4">
                    <div className="w-full max-w-full px-4">
                        <h2 className="text-[30px] lg:text-[40px] xl:text-[50px] font-semibold !leading-[1.5] text-[#020303]">
                            {news.title}
                        </h2>
                        {news.image && (
                            <div className="my-6 lg:my-12 relative">
                                <img src={`${news.image}`} alt={news.title} width="523" height="332" className="w-full h-auto" />
                            </div>
                        )}
                        <div
                            className="text-[18px] sm:text-[20px] lg:text-[22px] xl:text-[24px] font-light !leading-[1.5] text-[#020303] space-y-4"
                            dangerouslySetInnerHTML={{ __html: news.content }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default NewsUpdatesDetailPage;
